import { handleActions } from "redux-actions";
import { createRoutine } from "redux-saga-routines";

export const fetchOffersRoutine = createRoutine(
  "app/plan/FETCH_OFFERS_ROUTINE"
);

export const initialState = {
  offers: {
    loading: null,
    data: null,
    error: null
  }
};

export default handleActions(
  {
    [fetchOffersRoutine.TRIGGER]: state => state,
    [fetchOffersRoutine.REQUEST]: state => ({
      ...state,
      offers: { ...state.offers, loading: true, error: null }
    }),
    [fetchOffersRoutine.SUCCESS]: (state, action) => ({
      ...state,
      offers: {
        ...state.plans,
        loading: false,
        error: null,
        data: action.payload
      }
    })
  },
  initialState
);
